import { BuildChart, setBuildChartFromRequest } from "@/models/BuildChart";

export const RATING_OPTIONS = [
  "Super Preferred",
  "Preferred",
  "Preferred NT",
  "Preferred Tobacco",
  "Select",
  "Standard Plus",
  "Standard NT",
  "Standard Tobacco",
  "Class 1",
  "Class 2",
  "Table 1 Tobacco",
  "Table 2 Tobacco",
  "Table 3 Tobacco",
  "Table 4 Tobacco",
  "Table 5 Tobacco",
  "Table 6 Tobacco",
  "Table 7 Tobacco",
  "Table 8 Tobacco",
  "Table 9 Tobacco",
  "Table 10 Tobacco",
  "Table 1",
  "Table 2",
  "Table 3",
  "Table 4",
  "Table 5",
  "Table 6",
  "Table 7",
  "Table 8",
  "Table 9",
  "Table 10",
  "Table 11",
  "Table 12",
  "Table 13",
  "Table 14",
  "Table 15",
  "Table 16",
  "Table 17",
  "Table 18",
  "Table 19",
  "Table 20",
  "Guaranteed Issue",
  "Postponed",
  "Declined",
  "Level",
  "Level Tobacco",
  "Graded"
];

export function Build(model = {}) {
  return {
    buildChart: BuildChart(model?.buildChart),
    id: model.id,
    inches: model.inches,
    maxWeight: model.maxWeight,
    minWeight: model.minWeight,
    maxBmi: model.maxBmi,
    minBmi: model.minBmi,
    rating: model.rating
  };
}

export function setBuildFromRequest(raw = {}) {
  const build = Build();

  build.id = raw.id;
  build.inches = raw.inches;
  build.maxWeight = raw.max_weight;
  build.minWeight = raw.min_weight;
  build.maxBmi = raw.max_bmi;
  build.minBmi = raw.min_bmi;
  build.rating = raw.rating;
  build.buildChart = setBuildChartFromRequest(raw.build_chart);

  return build;
}
